import axios from '../utils/axiosConfig';

const billsAPI = {
  // Products
  getProducts: async (params) => {
    const response = await axios.get('/bills/products', { params });
    return response.data;
  },

  syncProducts: async () => {
    const response = await axios.post('/bills/sync-products');
    return response.data;
  },

  // Validation
  validateMeter: async (data) => {
    const response = await axios.post('/bills/validate/meter', data);
    return response.data;
  },

  validateTV: async (data) => {
    const response = await axios.post('/bills/validate/tv', data);
    return response.data;
  },

  // Electricity
  getElectricityProviders: async () => {
    const response = await axios.get('/bills/providers/electricity');
    return response.data;
  },

  purchaseElectricity: async (data) => {
    const response = await axios.post('/bills/electricity/purchase', data);
    return response.data;
  },

  // TV
  getTVProviders: async () => {
    const response = await axios.get('/bills/providers/tv');
    return response.data;
  },

  getTVPackages: async (serviceId) => {
    const response = await axios.get(`/bills/tv-packages/${serviceId}`);
    return response.data;
  },

  purchaseTV: async (data) => {
    const response = await axios.post('/bills/tv/purchase', data);
    return response.data;
  },

  // Transactions
  getTransactions: async (params) => {
    const response = await axios.get('/bills/transactions', { params });
    return response.data;
  },

  getTransactionSummary: async () => {
    const response = await axios.get('/bills/transactions/summary');
    return response.data;
  },

  getTransaction: async (transactionId) => {
    const response = await axios.get(`/bills/transactions/${transactionId}`);
    return response.data;
  },

  queryTransaction: async (transactionId) => {
    const response = await axios.post(`/bills/transactions/${transactionId}/query`);
    return response.data;
  },

  retryTransaction: async (transactionId) => {
    const response = await axios.post(`/bills/transactions/${transactionId}/retry`);
    return response.data;
  },
};

export default billsAPI;